// Import 3rd party libraries
import {gsap} from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);
gsap.registerPlugin(MotionPathPlugin);

export default function() {
    const matches = {
        isMobile: "(max-width: 480px)",
        isTablet: "(min-width: 481px) and (max-width: 768px)",
        isLaptop: "(min-width: 769px) and (max-width: 1024px)",
        isDesktop: "(min-width: 1025px) and (max-width: 1200px)",
        isTV: "(min-width: 1201px)",
        reduceMotion: "(prefers-reduced-motion: reduce)"
    }
    
    let mm = gsap.matchMedia();
    
    mm.add(matches, (context) => {

        if(!context.conditions.reduceMotion) {
            const paths = [
                "m102.24.42C53.68,31.85,1.17,76.48,4.24,126.42c4.31,70.36,115.53,95.71,118,162,1.14,30.48-20.58,73.51-122,128",
                "m.41.29c16.3,23.13,35.85,58.32,40,103,7.72,83.22-44.98,124.32-33,184,6.56,32.7,33.33,74.84,124,114",
                "m50.63.35C33.16,18.61,11.35,47.54,12.63,82.35c1.34,36.15,26.34,44.66,31,82,6,48.04-31.32,66.69-41,119-5.36,28.98-2.95,72.07,35,131",
                "m50.63.35C33.16,18.61,11.35,47.54,12.63,82.35c1.34,36.15,26.34,44.66,31,82,6,48.04-31.32,66.69-41,119-5.36,28.98-2.95,72.07,35,131",
                "m50.63.35C33.16,18.61,11.35,47.54,12.63,82.35c1.34,36.15,26.34,44.66,31,82,6,48.04-31.32,66.69-41,119-5.36,28.98-2.95,72.07,35,131",
                "m.5.02c.73,23.48,3.94,59.57,17,101,25.42,80.63,63.74,103.99,74,160,6.04,32.94,3.43,82.96-42,152",
                "m.5.02c.73,23.48,3.94,59.57,17,101,25.42,80.63,63.74,103.99,74,160,6.04,32.94,3.43,82.96-42,152",
                "m.5.02c.73,23.48,3.94,59.57,17,101,25.42,80.63,63.74,103.99,74,160,6.04,32.94,3.43,82.96-42,152"
            ]

            let socialSlides = document.querySelectorAll("#socials-background .social-image");
            let socialBadges = document.querySelectorAll("#socials-badges img");

            socialSlides.forEach((slide, i) => {
                let socialTween, badges;

                // add hover event listeners
                slide.addEventListener("mouseenter", () => {
                    // get the center of the slide
                    let slideCenter = slide.getBoundingClientRect().left + (slide.offsetWidth / 2);
                    badges = [...socialBadges].filter((badge) => Math.random() > 0.5);

                    // move the badge to the center of the slide
                    // not with gsap
                    badges.forEach((badge) => {
                        badge.style.left = slideCenter + "px";
                    });

                    // animate the badges
                    socialTween = gsap.from(badges, {
                        stagger: (i) => i < 5 ? i * .2 : (Math.random().toFixed(2) * 5) + 1,
                        duration: () => (Math.random().toFixed(2) * 10) + 2,
                        opacity: 1,
                        top: "4rem",
                        ease: CustomEase.create("custom", "M0,0,C0.126,0.382,0.192,0.401,0.278,0.6,0.432,0.958,0.818,1.001,1,1"),
                        motionPath: {
                            path: () => {return paths[Math.floor(Math.random() * paths.length)];},
                            align: "self",
                            alignOrigin: [0.5, 0.5],
                            start: 0
                        }

                    });

                    socialTween.then(() => {
                        socialTween.invalidate();
                        socialTween.revert();
                    });
                });

                slide.addEventListener("mouseleave", () => {
                    // kill the badge animation
                    socialTween.pause();
                    socialTween.invalidate();
                    socialTween.revert();

                    gsap.set(badges, { clearProps: "transform,opacity,top,left,scale,rotate,translate" });
                });
            });

            // animate start badges
            /*gsap.from(socialBadges, {
                scrollTrigger: {
                    trigger: "#socials",
                    start: "clamp(top 50%)",
                    end: "clamp(bottom top)",
                    scrub: false,
                    toggleActions: "play none none reset",
                },
                stagger: () => (Math.random().toFixed(2) * 5) + 1,
                duration: () => (Math.random().toFixed(2) * 10) + 3,
                opacity: 1,
                repeat: -1,
                top: "4rem",
                ease: CustomEase.create("custom", "M0,0,C0.126,0.382,0.192,0.401,0.278,0.6,0.432,0.958,0.818,1.001,1,1"),
                motionPath: {
                    path: () => {return paths[Math.floor(Math.random() * paths.length)];},
                    align: "self",
                    alignOrigin: [0.5, 0.5],
                    start: 0
                }
                
            });*/
        }

        /**
         * Social Slider
         */
        let socialTimeline = gsap.timeline({ repeat: -1 });
        let slider = document.getElementById("socials-background");

        window.socialTimeline = socialTimeline;

        socialSlider();

        window.addEventListener("resize", () => {
            // Clear Timeline
            socialTimeline.pause();
            socialTimeline.revert();
            //socialTimeline.clear();
            socialTimeline.invalidate();

            // Remove inline styles
            // Normally revert would do this, but it's not working
            // because we set the inline styles with gsap.set()
            let slides = document.querySelectorAll("#socials-background .social-image");
            gsap.set(slides, { clearProps: "all" });
            gsap.set(slides, { xPercent: (i) => i * 100 });

            // Rebuild the slider
            //socialSlider();
            socialTimeline.resume();
        });

        slider.addEventListener("mouseenter", socialSliderPause);
        slider.addEventListener("mouseleave", socialSliderResume);

        function socialSlider(setSlides = false) {
            var slides = document.querySelectorAll("#socials-background .social-image");

            var numSlides = slides.length;
            var wrap = gsap.utils.wrap(-100, (numSlides - 1) * 100);

            gsap.set(slides, { xPercent: (i) => i * 100 });

            //if(!context.conditions.reduceMotion) {
            socialTimeline
                .progress(0)
                .clear()
                .to(slides, {
                    scrollTrigger: {
                        trigger: "#socials",
                        start: "top 80%",
                        end: "bottom 0%",
                        toggleActions: "play none none reset",
                    },
                    duration: 100,
                    xPercent: "+=" + numSlides * 100,
                    ease: "none",
                    modifiers: {
                        xPercent: wrap
                    }
                })
            //}
        }

        function socialSliderPause() {
            socialTimeline.pause();
        }

        function socialSliderResume() {
            socialTimeline.resume();
        }
    });
}
